import React, { Fragment, useEffect, useRef, useState } from "react";
import { KTSVG } from "../../../_metronic/helpers";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { addAccountPriorityAsync, updateAccountPriorityAsync, resetSelectedRecordObjectInState } from "./PrioritySlice";
import { PriorityInitialsForAdd, PriorityInitialsForUpdate } from "./interfaces/PriorityClass";
import { ShowToast } from '../../../common/Toastr';
import * as yup from 'yup';
import { Formik } from 'formik';
import { Priority } from "./Priority";
import { getValueFromResource } from "../../../common/timeLiveFunction";

export const PriorityForm = (props: any) => {
    const [disabledCount, setDisabledCount] = useState(0)
     const { modelRef, t, oncloseModal } = props;
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(PriorityInitialsForAdd);
    const { selectedRecord,PriorityList, isLoading } = useAppSelector((state) => state.priority);
    const dispatch = useAppDispatch();

    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(PriorityInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            stateItem.IsDisabled = stateItem.IsDisabled === 'Yes' ? true : false;
            setCurrentFieldsData(stateItem);
        }
        else {
            setCurrentFieldsData(PriorityInitialsForAdd);
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }

        calculatedDisabledValue();
     }, [selectedRecord])

    const handleSubmit = (values: any) => {
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updateAccountPriorityAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Priority Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        else {
            dispatch(addAccountPriorityAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Priority Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        oncloseModal();
    }
    const calculatedDisabledValue = () => {
        if (PriorityList.length > 0) {
            let index = 0;
            PriorityList.forEach((value) => {
                if (value.IsDisabled.toString() == 'Yes') {
                    index = index + 1
                }
            });
            setDisabledCount(PriorityList.length - index);
        }
    }
    return (
        <>
            <Formik
                initialValues={currentFieldsData}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    Priority: yup
                        .string()
                        .label('TaskPriorityType')
                        .trim()
                        .required
                        // (t('Priority type is required')),
                        (getValueFromResource('Priority type is required',dispatch, t)),
                        PriorityOrder: yup
                        .number()
                        .min(0, 
                            // t('Value must be greater than or equal to 0'))
                            getValueFromResource('Delete',dispatch, t))
                        .max(255, 
                            // t('Value must be less than or equal to 255'))
                            getValueFromResource('Value must be less than or equal to 255',dispatch, t))

                        .required
                        // (t('Priority Order is required'))
                        (getValueFromResource('Priority Order is required',dispatch, t))

                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <form>
                            <div className='card-body'>
                                {isLoading ?
                                    <div className="col-md-12">
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-md ms-2'></span>
                                        </span>
                                    </div>
                                    : <>
                                        <div className="modal drawer-overlay" style={{ display: 'block' }}
                                        >
                                            <div className="modal-dialog">
                                                <div className="modal-content">
                                                    <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                                        <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ?
                                                        // t('Update') 
                                                        getValueFromResource('Update ',dispatch, t)
                                                        : 
                                                        // t('Add')} 
                                                        getValueFromResource('Add ',dispatch, t)}

                                                        {/* {t('Priority')}  */}
                                                        {getValueFromResource('Priority',dispatch, t)}

                                                        </h5>
                                                        <div
                                                            className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                                            onClick={oncloseModal}
                                                        >
                                                            <KTSVG
                                                                path="/media/icons/duotune/arrows/arr061.svg"
                                                                className="svg-icon svg-icon-1x"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="modal-body">
                                                        <form className='form'>
                                                            <div className="mb-0">
                                                                <label className="fs-7 fs-7 fw-normal">
                                                                    {/* {t('Priority')} */}
                                                                    {getValueFromResource('Priority',dispatch, t)}
                                                                    </label>
                                                                <input type="text" className="form-control fs-7 fw-normal mt-2" id='Priority' value={values.Priority} name='Priority'
                                                                    onChange={handleChange('Priority')}
                                                                    style={{ color: '#172b4d' }}
                                                                    ref={defaultFocusRef}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            setFieldTouched('Priority', true);
                                                                            handleSubmit();
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div style={{ paddingRight: 5, paddingBottom:5 }}>
                                                                {touched.Priority && errors.Priority &&
                                                                    <p className='errorMsg'>{errors.Priority as string}</p>
                                                                }
                                                            </div>     
                                                            <div className="mb-2 mt-2">
                                                                <label className="fs-7 fs-7 fw-normal">
                                                                    {/* {t('Priority Order')} */}
                                                                    {getValueFromResource('Priority Order',dispatch, t)}
                                                                    </label>
                                                                <input type="number" className="form-control fs-7 fw-normal mt-2" id='PriorityOrder' value={values.PriorityOrder} name='PriorityOrder'
                                                                    onChange={handleChange('PriorityOrder')}
                                                                    onBlur={() => setFieldTouched('PriorityOrder')}
                                                                    style={{ color: '#172b4d' }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            setFieldTouched('PriorityOrder', true);
                                                                            handleSubmit();
                                                                        }
                                                                    }}                                                                   
                                                                />
                                                                
                                                            </div>    
                                                            <div style={{ paddingRight: 5, paddingBottom:5 }}>
                                                                {touched.PriorityOrder && errors.PriorityOrder &&
                                                                    <p className='errorMsg'>{errors.PriorityOrder as string}</p>
                                                                }
                                                            </div>                                                     
                                                            {Object.keys(selectedRecord).length > 0 ? (
                                                                    disabledCount !== 1 ? <div className="mb-3" >
                                                                        <label className="fs-7 fw-normal mt-2">
                                                                            {/* {t('Disabled')} */}
                                                                            {getValueFromResource('Disabled',dispatch, t)}
                                                                            </label>
                                                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                            <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                                onChange={handleChange('IsDisabled')}
                                                                            />
                                                                        </div>
                                                                    </div> : PriorityList.find(x => x.AccountPriorityId === values.AccountPriorityId)?.IsDisabled.toString() === "Yes" && (<div className="mb-3" >
                                                                        <label className="fs-7 fw-normal mt-2">
                                                                            {/* {t('Disabled')} */}
                                                                            {getValueFromResource('Disabled',dispatch, t)}
                                                                            </label>
                                                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                            <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                                onChange={handleChange('IsDisabled')}
                                                                            />
                                                                        </div>
                                                                    </div>)
                                                                ) : null}
                                                        </form>
                                                    </div>
                                                    <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                                            onClick={oncloseModal}
                                                        >
                                                            {/* {t('Cancel')} */}
                                                            {getValueFromResource('Cancel',dispatch, t)}
                                                        </button>
                                                        <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm" onClick={() => handleSubmit()} disabled={!isValid}>
                                                        {/* {t('Save')}   */}
                                                        {getValueFromResource('Save',dispatch, t)}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </form>
                    </Fragment>
                )}
            </Formik>
        </>
    )
}
